import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { AiFillWarning, AiOutlineCamera } from 'react-icons/ai'
import { RiCloseCircleFill } from 'react-icons/ri'
import Resizer from "react-image-file-resizer";

import t from 'helpers/I18n'


const IdInputField = ({error, name, nameLabel, type, content, getInputValue, dataFile, setDataToContext, step_ID, step_URL}) => {
    // Error
    const hasError = error.length > 0
    const getError = (id) => hasError && error.find(error => error.id === id)
    const _error = name === getError(name)?.id && getError(name)
    const [inputError, setInputError] = useState(_error ? _error : false)
    const cleanErrorMessage = () => { setInputError(false) }
  
    // id file input /////////////////////////////////////////////////////////////
    const IdInput = () => {
    const iderror_className = inputError ? "error" : ""
    const idfield_ClassName = "idField idField-" + name
    const reader = new FileReader()
    const sizeLimit = 5500000
    const sizeLastLimit = 750000
    const typeLimit = ["image/jpeg", "image/png"];
    const [data_file, setData_file] = useState(dataFile)
    const [id, setId] = useState({})

    const getInputFlie = async (e) => {
      cleanErrorMessage()
      const file = e.target.files[0]
      const postInputId = (name, image) => {
         const inputId = {
            "mediaId": name,
            "fileName": `optimized_${name}.JPEG`,
            "fileBody": image.split(',')[1]
        }
        console.log('about the send image')
          getInputValue(name, inputId)
      }

      if (!typeLimit.includes(file?.type)) {
        setInputError({ id: name, error: t('error_messages.image_type_limit') })
        return
      }

      if (file?.size > sizeLimit) {
        setInputError({ id: name, error: t('error_messages.image_size_limit') })
        return
      }

      if (typeLimit.includes(file?.type) && file?.size < sizeLimit) {
        setId({ name: file?.name })

        // if (file?.size < sizeLastLimit) {
        //   reader.onload = function(e) {
        //     const image = e.target.result
        //     console.log(file)
        //     // postInputId(name, image)
        //     return
        //   };
        //   reader.readAsDataURL(file);
        // } else {
          const image = await resizeFile(file);
          postInputId(name, image)
        // }
      }
    }
      
    const handleDeleteImage = (e) => {
        e.preventDefault()
        setDataToContext(step_ID, step_URL, name, undefined)
        setData_file(undefined)
        getInputValue(name, undefined)

        setId({})
        cleanErrorMessage()
    }
      
    const resizeFile = (file) => 
      new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            800,
            600,
            "JPEG",
            100,
            0,
            (uri) => {
              resolve(uri);
            },
            "base64"
          )
      });


      return (
        <div className={idfield_ClassName}>
          <p>{ content.label }</p>
          <label htmlFor={name} className={`id-input ${iderror_className}`}>
            {(!id.name && !data_file) && 
              <div>
                  <p className="icon">
                  <AiOutlineCamera />
                  </p>
                  <p>
                    <span>{ content.contentTitle } </span>
                    <span>{ content.contentbody }</span>
                  </p>
              </div>
            }
          
            {(id.name || data_file)  && 
            <div className={"has-file"}>
              <p>{ nameLabel.toUpperCase() }</p>
              <div className="" onClick={handleDeleteImage}><RiCloseCircleFill size={"1.5em"}/></div>
            </div>
            }
            <input type="file" id={name} onChange={getInputFlie} disabled={ id.name } />
          </label>
          {inputError &&
            <p className={"error-message"}>
                <AiFillWarning className={"warning"} size={"1.5em"} />
                {inputError.error}
          </p>}
        </div>
      )
    }
    if (type === "idInput") return IdInput()
};

IdInputField.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    error: PropTypes.array,
    checked: PropTypes.any,
    phoneCode: PropTypes.any,
    options: PropTypes.array,
    isNNumber: PropTypes.bool,
    isBCE: PropTypes.bool,
    getInputValue: PropTypes.func,
    max: PropTypes.number,
};

IdInputField.defaultProps = {
    type: "text",
    error: []
}

export default IdInputField
